import React, { Component } from 'react';
import { NavLink, Redirect } from 'react-router-dom';

import Analytics from 'APP_ROOT/services/analytics';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import Events from '../../common/events';
import { strings, getCurrentLocale } from '../../../localization';
import PasswordPolicyChecklist from '../../common/passwordPolicyChecklist';

export default class ResetPasswordPage extends Component {

    constructor(props) {

        super(props);
        this.state = {
            validateConfirmationNumberPwMessage: null,
            validateNewPwMessage: null,
            validateConfirmNewMessage: null,
            validationFailed: false,
            errorMessage: null,
            success: false,
            newPassword: '',
            isNewPasswordValid: false
        };
    }

    componentDidMount() {
        Analytics.pageView();
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        if (!CognitoUtil.cognitoUser) {
            this.setState({redirectToSignIn: true})
        }
    }

    onNewPasswordChange = (e) => {      
        this.setState({ 
            newPassword: e.target.value
        });
    }

    onResetPasswordSumbit = (e) => {

        e.preventDefault();
        if (this.validateForm()) {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.reset_pw_updating) } }));
            CognitoUtil.confirmPassword(this.confirmationNumber.value, this.newPassword.value, this.onConfirmPasswordSuccess, this.onConfirmPasswordFail);
        }
    }

    onConfirmPasswordSuccess = e => {

        // this.props.loginPage.onLoginSuccess(e);
        //do nothing... cognitoUtil falls through to login_success, or SHOULD TODO test that
        console.log("Confirm password success");
        this.setState({ success: true });
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onConfirmPasswordFail = e => {

        this.setState({ errorMessage: strings.formatString(strings.new_pw_error_unknown) });
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    validateForm() {

        var confirmationNumberV = this.confirmationNumber.value.length > 0;
        var newPasswordV = this.newPassword.value.length > 0;
        var confirmNewPasswordV = this.confirmNewPassword.value.length > 0;
        var newPasswordMatch = this.newPassword.value === this.confirmNewPassword.value;
        if (confirmationNumberV && newPasswordV && confirmNewPasswordV && newPasswordMatch) {
            this.setState({
                validateConfirmationNumberPwMessage: null,
                validateNewPwMessage: null,
                validateConfirmNewMessage: null,
            });
            return true;
        } else {
            var confirmationNumMessage = confirmationNumberV === true ? null : strings.formatString(strings.signup_error_required);
            var newPwMessage = newPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var confirmNewPwMessage = confirmNewPasswordV === true ? null : strings.formatString(strings.signup_error_required);
            var newPwMatchMessage = newPasswordMatch === true ? null : strings.formatString(strings.password_error_match)

            this.setState({
                validateConfirmationNumberPwMessage: confirmationNumMessage,
                validateNewPwMessage: newPwMessage ? newPwMessage : newPwMatchMessage,
                validateConfirmNewMessage: confirmNewPwMessage ? confirmNewPwMessage : newPwMatchMessage,
            });
            return false;
        }
    }

    render() {

        if (this.state.redirectToSignIn) {
            return <Redirect to='/' />;
        }

        var confirmationNumberMessage = this.state.validateConfirmationNumberPwMessage ?
            <p className="error-message">{this.state.validateConfirmationNumberPwMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var newPwMessage = this.state.validateNewPwMessage ?
            <p className="error-message">{this.state.validateNewPwMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var confirmNewPwMessage = this.state.validateConfirmNewMessage ?
            <p className="error-message">{this.state.validateConfirmNewMessage}</p> :
            <p className="error-message">&nbsp;</p>;

        var errorMessage = this.state.errorMessage ?
            <p className="error-message"><i className="material-icons">error_outline</i>{this.state.errorMessage}</p> :
            <p className="error-message">&nbsp;</p>;

        return (
            <div className="container form-card">

                <div className="row">

                    <div className="col-6">

                        <h2>{strings.formatString(strings.reset_pw_title)}</h2>
                        <p>{strings.formatString(strings.reset_pw_m1)}</p>

                        <form className="row" onSubmit={this.onResetPasswordSumbit}>

                            <div className="col-12 col-sm-6">
                                <label htmlFor="confirmationNumber">{strings.formatString(strings.app_confirmation_number)}</label>
                                <input id="confirmationNumber" ref={(confirmationNumber) => { this.confirmationNumber = confirmationNumber }} type="password" placeholder="eg. 12345" />
                                {confirmationNumberMessage}
                            </div>

                            <div className="col-12"></div>

                            <div className="col-12 col-sm-6">
                                <label htmlFor="newPassword">{strings.formatString(strings.password_new_title)}</label>
                                <input id="newPassword" ref={(newPassword) => { this.newPassword = newPassword }} type="password" placeholder="******"  value={this.state.newPassword} onChange={this.onNewPasswordChange} />
                                {newPwMessage}
                            </div>

                            <div className="col-12 col-sm-6">
                                <label htmlFor="confirmNewPassword">{strings.formatString(strings.password_new_confirm_title)}</label>
                                <input id="confirmNewPassword" ref={(confirmNewPassword) => { this.confirmNewPassword = confirmNewPassword }} type="password" placeholder="******" />
                                {confirmNewPwMessage}
                            </div>

                            <div className="col-12 col-sm-6">
                                <PasswordPolicyChecklist password={this.state.newPassword} onPolicyCheck={(result) => { if(result !== this.state.isNewPasswordValid) this.setState({isNewPasswordValid: result})}} />
                            </div>

                            <div className="col-12 col-sm-6 action-btns text-right">
                                <input type="submit" className="btn" value="Save" disabled={!this.state.isNewPasswordValid} />
                                {errorMessage}
                                {this.state.success ?
                                    <div>
                                        <p className="success-message"><i className="material-icons">check_circle</i>{strings.reset_pw_confirm_message}</p>
                                        <NavLink to={"/" + getCurrentLocale() + "/"}>{strings.formatString(strings.reset_pw_login_message)}</NavLink>
                                    </div>
                                    : null}
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        );
    }
}
